import React from 'react';
import {connect} from 'react-redux';
import {Route, Switch, Redirect} from 'react-router-dom';
import Training from './Pro.Training';
import WrongNotes from './Pro.WrongNote';
import Analysis from './Pro.Analysis';
import Coach from './Pro.Coach';
import SessionDetail from './Pro.SessionDetail';
import {ProRoot} from '../components/Root';
import '../styles/css/pro.notes.css';

class Pro extends React.Component{

  constructor(props){
    super(props);
    this.state={
      location:null
    };
  }

  shouldComponentUpdate(nextProps, nextState){
    if(this.props.location === nextProps.location){
      return false;
    }else{
      return true
    }
  }

  render(){
    let {location, is_first} = this.props;

    return(
      <ProRoot is_first={is_first} pathName={location.pathname}>
        <Switch>
          <Route exact path={'/premium'} render={()=><Redirect to="/premium/personal-training" />} />
          <Route exact path={'/premium/personal-training'} component={Training} />
          <Route exact path={'/premium/personal-training/:session_num'} component={SessionDetail} />
          <Route exact path={'/premium/wrong-notes'} component={WrongNotes} />
          <Route exact path={'/premium/analysis'} component={Analysis} />
          <Route exact path={'/premium/coach'} component={Coach} />
        </Switch>
      </ProRoot>
    );
  }

}

const mapStateToProps = state =>{
  return{
    is_first: state.coach.is_first
  }
}

export default connect(mapStateToProps)(Pro);



// WEBPACK FOOTER //
// ./src/containers/Pro.Container.js